import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box, Paper } from '@mui/material';

const DebugEventDetails: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const [debugData, setDebugData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDebugData = async () => {
      try {
        console.log('🔍 Debug: Fetching event details for:', eventId);
        
        const response = await fetch(`http://localhost:4000/api/events/${eventId}`);
        const data = await response.json();
        
        console.log('🔍 Debug: Raw API response:', data);
        
        setDebugData(data);
        setLoading(false);
      } catch (err: any) {
        console.error('🔍 Debug: Error fetching event:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    if (eventId) {
      fetchDebugData();
    }
  }, [eventId]);

  if (loading) return <div>Loading debug data...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        🔍 Event Debug Data
      </Typography>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6">Event ID: {eventId}</Typography>
        
        {debugData && debugData.event && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1">Event Name: {debugData.event.eventName}</Typography>
            <Typography variant="subtitle1">Item Count: {debugData.event.itemCount}</Typography>
            <Typography variant="subtitle1">
              Item IDs: {debugData.event.itemIds ? JSON.stringify(debugData.event.itemIds) : 'null'}
            </Typography>
            <Typography variant="subtitle1">
              Linked Items Count: {debugData.event.linkedItems ? debugData.event.linkedItems.length : 0}
            </Typography>
            
            {debugData.event.linkedItems && debugData.event.linkedItems.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="h6">🎯 Linked Items:</Typography>
                {debugData.event.linkedItems.map((item: any, index: number) => (
                  <Box key={index} sx={{ p: 1, border: '1px solid #ccc', my: 1 }}>
                    <Typography>Name: {item.name}</Typography>
                    <Typography>Category: {item.category}</Typography>
                    <Typography>Condition: {item.condition}</Typography>
                    <Typography>Description: {item.description}</Typography>
                    <Typography>Images: {item.images?.length || 0}</Typography>
                    <Typography>User ID: {item.userID}</Typography>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        )}
        
        <Box sx={{ mt: 3 }}>
          <Typography variant="h6">🔍 Raw API Response:</Typography>
          <pre style={{ fontSize: '12px', overflow: 'auto' }}>
            {JSON.stringify(debugData, null, 2)}
          </pre>
        </Box>
      </Paper>
    </Container>
  );
};

export default DebugEventDetails;